var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleavatar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 128 128",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_11100_",
    cx: 64,
    cy: 64,
    fill: "#d1d1d3",
    r: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_893_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1266_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1202_",
    d: "m119.3 96.2c-5.4 9.3-13.2 17.2-22.5 22.7-1.3.8-2.6 1.5-3.9 2.2-8.7 4.4-18.5 6.9-28.9 6.9s-20.2-2.5-28.9-6.9c-1.3-.7-2.7-1.4-3.9-2.2-9.3-5.6-17-13.4-22.4-22.7 1.6-9 8-16.4 16.7-19.4l19.5-6.7 2.8-1h.1l2.1-2.7h27.8l2.5 2.7h.1l2.8 1 19.3 6.6c8.9 3.1 15.2 10.5 16.8 19.5z",
    fill: "#5e86c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1291_",
    d: "m47.5 54.8c.6 4.8 1.2 10.7.3 14.5.4 1.1.8 2.3 1.2 3.4 2.2 6.5 8.3 8.7 15.2 8.7 6.9 0 13-2.3 15.2-8.8.4-1.1.8-2.2 1.2-3.3-.9-3.8-.2-9.7.3-14.5.6-4.9 1.3-8 1.5-7.8-10-10-26.3-10-36.3 0 .1-.2.9 2.9 1.4 7.8z",
    fill: "#f1b97c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1284_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1289_",
    cx: 84.9,
    cy: 42.3,
    fill: "#f8cfa3",
    rx: 7.3,
    ry: 4.3,
    transform: "matrix(.18 -.984 .984 .18 27.999 118.237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1288_",
    d: "m86.5 36.7c-.3 3-.6 5-.6 5-.5 2.5-.9 4.6-1.3 6.4 1.3-.5 2.7-2.4 3.2-5.3.6-2.9-.2-5.4-1.3-6.1z",
    fill: "#f1b97c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1287_",
    d: "m64 7.8c-24.2 1.1-23.1 19.5-23.1 19.5 0 7.3 1.2 14.4 1.2 14.4 2.8 15.5 4.6 16.6 4.6 16.6 2.2 3.2 5.2 5.8 7.6 7.5 2.3 1.7 5.2 2.7 8 2.7h3.3c2.9 0 5.7-.9 8-2.7 2.4-1.8 5.3-4.3 7.6-7.5 0 0 1.8-1.1 4.6-16.6 0 0 1.2-7.2 1.2-14.4 0 0 1.1-18.4-23-19.5z",
    fill: "#f8cfa3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1286_",
    cx: 43,
    cy: 42.3,
    fill: "#f8cfa3",
    rx: 4.3,
    ry: 7.3,
    transform: "matrix(.984 -.18 .18 .984 -6.911 8.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1285_",
    d: "m41.4 36.7c.3 3 .6 5 .6 5 .5 2.5.9 4.6 1.3 6.4-1.3-.5-2.7-2.4-3.2-5.3s.2-5.4 1.3-6.1z",
    fill: "#f1b97c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1283_",
    d: "m64.4 81.6-.1-.1.1-.1z",
    fill: "#5e86c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1282_",
    d: "m83.4 70.1v.1c-.4 1-.8 2.1-1.1 3.3-1.3 3.8-3.7 6.7-7.3 8.5-2.9 1.5-6.5 2.3-10.7 2.3-9.2 0-15.6-3.8-18-10.7-.4-1.3-.8-2.3-1.2-3.3 0-.1 0-.1 0-.2l2.8-1v.1c.4 1.1.8 2.3 1.2 3.4 2.2 6.5 8.3 8.7 15.2 8.7s13-2.3 15.2-8.8c.4-1.1.8-2.2 1.2-3.3v-.1z",
    fill: "#e7e7e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1279_",
    fill: "#4c5aa5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1016_",
    d: "m35.1 121.1c-1.3-.7-2.7-1.4-3.9-2.2v-11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_989_",
    d: "m96.9 107.1v11.8c-1.3.8-2.6 1.5-3.9 2.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1277_",
    d: "m42.2 42.4h.5c.1-3.1.8-15.2 4.1-18.4 0 0 11.3 10.2 37 6.5-.3 4.7.2 8.6 1.2 11.9h.8c.2-2.3.9-8.1 2.7-12.3 1.4-3.3 1.8-7 .8-10.5-1.8-5.6-7.2-12.1-23.1-13.7-4-.4-8-.1-11.8 1-4.6 1.4-9.9 4.3-11.7 10.4 0 0-9 3.2-1.1 22z",
    fill: "#4c525e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1273_",
    d: "m47.8 14.8s.2-.1.5-.3c3.2-1.9 7.4-3.3 12-3.7-8.1 1-12.7 5-12.7 5s5-3.9 14.6-4.4c-6.5.7-10.3 3.5-10.3 3.5s4.8-2.3 6.9-2.3c-4.4.9-8.4 3.5-6.7 2.6 3.1-1.5 7-2.4 11.3-2.5-7.5.3-12 3.6-12 3.6s5.1-3.3 13.6-3c-11.1.2-15.7 4.7-15.7 4.7s2.7-2 8.3-3.3c-1.3.5-4.2 1.2-7.1 3.1-1 .6-1.4 1.1-1.4 1.1 2.6-1.9 7.5-3.8 12.8-4-5.7.7-9 3.3-9 3.3 0-.1 2.6-1.2 2.7-1.2 2-.7 3.4-.9 3.4-.9-4.2 1-6.2 2.6-6.2 2.6s.1-.1.4-.2c3-1.5 6.5-2.2 9.9-2.3-6.7.3-10.5 3.4-10.5 3.4s4.6-2.9 12-2.6c-5.4.2-8.4 2.4-8.4 2.4s.1-.1.3-.1c6.6-2.8 15.4-1.3 22 4.1.2.2 2.5 2.3 2.6 2.5 0 0-1.6-3.1-5.8-5.7 5.2 2.5 7.7 6.3 7.7 6.3s-1.8-3.7-6.3-6.6c5.5 3.7 7.1 6.5 7.1 6.5s-2.5-5.4-9.8-8.9c5.9 2.2 9.1 6.1 9.1 6.1s-1.8-2.8-5.3-5.1c3.5 2.1 5.9 5 5.9 5s-.2-.3-.6-.9c.5.5.8.8.8.8s-2.1-3.5-6.5-6.1c6.4 3.2 7.4 6.4 8.4 7 0 0-2.1-4.2-7.1-7.4 5.4 3.3 8 7.3 8 7.3s-2.7-5.9-11-10c6.7 2.6 10.2 7 10.2 7s-.3-.4-.9-1.2c-2.1-2.5-4.6-4.6-7.7-6.2 1 .5 4.6 2.1 8.4 6.1.7.7 1 1.1 1 1.1s-2.8-4.6-8.9-7.8c-16.5-8.7-30 1.6-30 1.6z",
    fill: "#535963"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleavatar4);
export default __webpack_public_path__ + "static/media/Maleavatar_4.fc1cac401e0027278249484cf14e5395.svg";
export { ForwardRef as ReactComponent };